import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addPayBy, deletePayBy, getAllPayBy, updatePayBy } from '../../redux/rtk/features/masters/payBySlice';
import PageTitle from '../page-header/PageHeader';

const ShowPayByMaster = () => {
  const { Title } = Typography;
  const [editingPayBy, setEditingPayBy] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.payBy);


  useEffect(() => {
    dispatch(getAllPayBy());
  }, [dispatch]);



  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingPayBy) {
        // Update existing payBy
        const result = await dispatch(
          updatePayBy({ id: editingPayBy.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllPayBy());
        } else {
          message.error('Error updating payBy!');
        }
      } else {
        // Add new payBy
        const result = await dispatch(addPayBy(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllPayBy());
        } else {
          message.error('Error adding payBy!');
        }
      }
      setEditingPayBy(false);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      message.error('Failed to add or update payBy!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deletePayBy(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllPayBy()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Pay By',
      dataIndex: 'payBy',
      key: 'payBy',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {setEditingPayBy(record);
            form.setFieldsValue(record);
          }}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this pay by?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingPayBy ? 'Edit Pay By' : 'Add Pay By'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="payBy-form"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
          <Form.Item
            name="payBy"
            label="Pay By"
            rules={[{ required: true, message: 'Please enter a pay by!' }]}
          >
            <Input placeholder="Enter payBy" />
          </Form.Item>

          <Button type="primary" block htmlType="submit">
                {editingPayBy ? 'Update Pay By' : 'Add Pay By'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Pay By List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ShowPayByMaster;
